import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
 import { AuthGuard } from './auth/auth-guard.service';
// import { PatientDocumentComponent } from './ipd/patient-document/patient-document.component';
// import { PatientdocsComponent } from './table-list/patientdocs/patientdocs.component';
// import { Webcam_photoComponent } from './table-list/webcam_photo/webcam_photo.component';
// import { WhatsappMessageComponent } from './whatsapp-message/whatsapp-message.component';
import { PrintOTConsentComponent } from './ipd/print-otconsent/print-otconsent.component';
import { ImageAnalyzerComponent } from './image-analyzer/image-analyzer.component';



const routes: Routes =[
  // {path:'ipddoc',component:PatientDocumentComponent},
  // {path:'opddoc',component:PatientdocsComponent},
  // {path:'uploadDocument',component:PatientDocumentComponent},
  // {path:'uploadPhoto',component:Webcam_photoComponent},
  // {path:'whatsapp-Message',component:WhatsappMessageComponent},
  {path:'print-otconsent', component:PrintOTConsentComponent},
  //  {
  //   path: '',
  //   loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  // },
   {path: 'image-analyzer', component: ImageAnalyzerComponent},
  {
    path: 'layout', canActivate: [AuthGuard],
    loadChildren: () => import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule)
},
{
    path: 'opticaldashboard',
    loadChildren: () => import('./optical-module/optical-module.module').then(m => m.OpticalModule)
}
 
   
];

@NgModule({
  imports: [
     CommonModule,
     BrowserModule,
    RouterModule.forRoot(routes)
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
